import { Tooltip, Typography } from '@mui/material';
import React from 'react';
// import Dashboard from 'types/entities/Dashboard';

type DepartmentHub = string | { department_name?: string } | null | undefined;

type KpiWorkunitGridData = {
  order?: {
    affair?: {
      department_hub?: DepartmentHub;
    };
  };
};

const ProjectDeptCell = React.memo(({ row }: { row?: KpiWorkunitGridData }) => {
  const hub = row?.order?.affair?.department_hub;

  const departmentName = typeof hub === 'string' ? hub : hub?.department_name;

  if (!departmentName) return null;

  return (
    <Tooltip title={departmentName}>
      <Typography variant="body2" noWrap>
        {departmentName}
      </Typography>
    </Tooltip>
  );
});

export default ProjectDeptCell;
